import Push from "push.js";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Favicon from "~@/assets/image/non-svg/favicon-32x32.png";
import {
  OrganizationStatus,
  useGetOrganizationsQuery,
  useWatchPushNotificationsSubscription,
} from "~@/graphql/codegen/generated";
import { MetaData } from "~@/pages/home/types/MetaData";

// Хук для подписки на push-уведомления
const useWatchPushNotifications = (userId: string) => {
  const navigate = useNavigate();

  const { data: organizationsData } = useGetOrganizationsQuery();

  const currentOrganization = useMemo(() => {
    return organizationsData?.getOrganizations?.current;
  }, [organizationsData]);

  const isInactive = useMemo(() => {
    return (
      (currentOrganization?.status === OrganizationStatus.Inactive &&
        (currentOrganization.isCanceled ||
          currentOrganization.isPaymentFailed)) ??
      false
    );
  }, [currentOrganization]);

  // Подписка на push-уведомления
  useWatchPushNotificationsSubscription({
    variables: { userId },
    skip: !userId || isInactive, // Пропускаем подписку, если нет userId
    onData({ data: newNotification, client: { cache } }) {
      const notification = newNotification.data?.watchPushNotifications; // Получаем данные уведомления
      const metadata: MetaData | null =
        typeof notification?.metadata === "string"
          ? JSON.parse(notification?.metadata)
          : null; // Парсим метаданные уведомления

      if (notification && metadata)
        Push.create(notification.title, {
          body: notification.body,
          icon: Favicon, // Иконка для уведомления
          timeout: 4000, // Время отображения уведомления
          onClick: function () {
            // Действия при клике на уведомление
            if ("clientId" in metadata) {
              navigate(`/clients#${metadata.clientId}`); // Переход к клиенту
            }
            if ("calendarEventId" in metadata) {
              navigate(`/agenda#${metadata.calendarEventId}`); // Переход к событию календаря
            }
            if ("roomId" in metadata) {
              navigate(`/chats/${metadata.roomId}`); // Переход к чату
            }
          },
        });
    },
  });
};

export default useWatchPushNotifications;
